"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateBillingAddress = void 0;
const types__graphql_1 = require("@caterdesk/types--graphql");
const types_shared_1 = require("../types.shared");
const ts_pattern_1 = require("ts-pattern");
const gmServiceLocationToAddress = (location) => (0, ts_pattern_1.match)(location)
    .with({ __typename: ts_pattern_1.P.union('AccountLocation', 'NewAccountLocation') }, ({ address }) => address)
    .with({ __typename: 'Address' }, (address) => address)
    .exhaustive();
const validateBillingAddress = ({ paymentMethod, billingAddress, }) => (0, ts_pattern_1.match)(paymentMethod)
    .with(null, () => ({
    result: (0, types_shared_1.error)({ code: 'NO_PAYMENT_METHOD' }),
}))
    .with(types__graphql_1.PaymentMethod.Invoice, () => ({
    result: (0, types_shared_1.ok)(),
}))
    .with(types__graphql_1.PaymentMethod.Card, () => {
    if (!billingAddress)
        return {
            result: (0, types_shared_1.error)({ code: 'NO_BILLING_ADDRESS' }),
        };
    const labelValidationResult = (0, ts_pattern_1.match)(billingAddress)
        .with({ __typename: ts_pattern_1.P.union('AccountLocation', 'Address') }, () => (0, types_shared_1.ok)())
        .with({ __typename: 'NewAccountLocation' }, ({ label }) => label ? (0, types_shared_1.ok)() : (0, types_shared_1.error)({ code: 'NO_BILLING_ADDRESS_LABEL' }))
        .exhaustive();
    if (labelValidationResult.type === 'error')
        return {
            result: labelValidationResult,
        };
    const address = gmServiceLocationToAddress(billingAddress);
    if (!address.street)
        return {
            result: (0, types_shared_1.error)({ code: 'NO_BILLING_ADDRESS_STREET' }),
        };
    if (!address.postcode)
        return {
            result: (0, types_shared_1.error)({ code: 'NO_BILLING_ADDRESS_POSTCODE' }),
        };
    if (!address.city)
        return {
            result: (0, types_shared_1.error)({ code: 'NO_BILLING_ADDRESS_CITY' }),
        };
    if (!address.country)
        return {
            result: (0, types_shared_1.error)({ code: 'NO_BILLING_ADDRESS_COUNTRY' }),
        };
    return {
        result: (0, types_shared_1.ok)(),
    };
})
    .exhaustive();
exports.validateBillingAddress = validateBillingAddress;
